import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createVoucherConfig} from '../api';
import {QUERY__VOUCHER_CONFIGS} from '../queryKeys';

export const useCreateVoucherConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createVoucherConfig,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__VOUCHER_CONFIGS],
      });
    },
  });
};
